<div class="side-bar" [ngClass]="{ open: isSidebarOpen }">
  <span *ngIf="!isSidebarOpen" class="mt-2 hamburger-icon">
    <img [src]="hamburgerPath" alt="hamburger-icon" (click)="toggleSideBar('open')" />
  </span>
  <span class="close-menu" *ngIf="isSidebarOpen" (click)="toggleSideBar('close')">
    <img [src]="timesPath" alt="times-icon" />&nbsp;Close
  </span>
  <ul>
    <li *ngFor="let path of visibleLinksData" (click)="navigateToRoute(path.route); toggleSideBar('close')">
      <img
        [src]="this.activeRoute.includes(path.route) ? path.active_icon : path.icon"
        alt="icon for {{ path.label }}"
        title="{{ path.label }}"
        class="shadow-none img-fluid"
      />
      <span
        *ngIf="isSidebarOpen"
        class="nav-item-label"
        [ngClass]="[this.activeRoute.includes(path.route) ? 'active-color' : '']"
        >{{ path.label }}</span
      >
    </li>
  </ul>
  <div *ngIf="userInitials" class="rail-avatar" [ngClass]="{ open: isSidebarOpen }">
    <span class="avatar-circle">{{ userInitials }}</span>
  </div>
</div>
